import request from '@/src/apis/axios';
import { ListResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import { AddressDto } from '@/src/models/AddressDto';
import { GetCustomerAddressesRequestParams } from '@/src/apis/rest/address.dtos';

const URL = {
  customerAddress: '/admin/customer-addresses/{customerId}',
};

// 관리자 소비자의 주소 목록 조회
export const getCustomerAddressAPI = async (
  requestParams: GetCustomerAddressesRequestParams,
) => {
  const { page = 1, pageSize = 10, customerId, ...rest } = requestParams;

  const { data } = await request<ListResponse<AddressDto>>({
    method: 'get',
    url: URL.customerAddress.replace('{customerId}', String(customerId)),
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(AddressDto, data.rows);

  return { rows, count: data.count };
};
